import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import "./scss/index.scss";
import classNames from "classnames";
import { RichText } from "prismic-reactjs";
import React, { useState } from "react";
import { Link } from "react-router-dom";
export function SliceColorSample(_ref) {
  var primary = _ref.primary,
      fields = _ref.fields,
      isMinimalist = _ref.isMinimalist;

  var _useState = useState(""),
      _useState2 = _slicedToArray(_useState, 2),
      activeColor = _useState2[0],
      setActiveColor = _useState2[1];

  return React.createElement("div", {
    className: "color-sample container"
  }, React.createElement("div", {
    className: "page-title"
  }, primary.title && React.createElement(RichText, {
    render: primary.title
  })), React.createElement("div", {
    className: "color-sample__colors"
  }, fields && (fields === null || fields === void 0 ? void 0 : fields.map(function (c, i) {
    return React.createElement("button", {
      type: "button",
      className: classNames("color-sample__colors-item", {
        active: c.color === activeColor
      }),
      style: {
        backgroundColor: c.color || ""
      },
      onClick: function onClick() {
        return setActiveColor(c.color);
      },
      key: i
    }, c.color);
  }))), React.createElement("div", {
    className: "color-sample__descr"
  }, primary.text && React.createElement(RichText, {
    render: primary.text
  })), primary.cta_link && React.createElement("div", {
    className: "color-sample__link"
  }, React.createElement(Link, {
    className: "button red",
    to: isMinimalist ? "/product/sample-minimalist/26" : "/product/color-sample-classic/25"
  }, primary.cta_label)));
}
SliceColorSample.componentName = "color_sample";
export default SliceColorSample;